module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frantmatter01"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("I. YOU: IDENTITY • ANXIETY • MONEY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("1. Why Did the Master Say “Game”?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("2. Mister Johnson’s Reading List “… "), _c('i', [_vm._v("the dominant note of our time is unreality")]), _vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Can Ink Blots Tell You Whether You Are the Type Who Will Make a Lot of Money in the Market?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Is the Market Really a Crowd?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. You Mean "), _c('i', [_vm._v("That’s")]), _vm._v(" What Money Really Is?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. What Are They in It For?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A. Cuddling Comsat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("B. I Want to Be Loved for Myself")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("C. Was I Dumb! Was I Dumb! Kick Me")]), _vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("D. IBM as Religion: Don’t Touch, Don’t Touch")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("E. The Broker as Witch-Doctor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("F. Can I Tell Rosalind? Can I Tell Harriet")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("G. They Make Me Do Everything Wrong")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Identity and Anxiety")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Where the Money Is")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Mr. Smith Admits His Biases")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. IT: SYSTEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Can Footprints Predict the Future?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. What the Hell Is a Random Walk?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Computers and Computeers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. But What Do the Numbers Mean?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Why Are the Little People Always Wrong?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. THEY: THE PROS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Cult of Performance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Lunch at Scarsdale Fats’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Losers and Winners: Poor Grenville, Charley, and the Kids")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Timing, and a Diversion: The Cocoa Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. VISIONS OF THE APOCALYPSE: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CAN IT ALL COMB TUMBLING DOWN?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. My Friend the Gnome of Zurich Says a Major Money Crisis Is On Its Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. If All the Half Dollars Have Disappeared, Is Something Sinister Gaining on Us?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. VISIONS OF THE MILLENNIUM: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DO YOU REALLY WANT TO BE RICH?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The Purposive Investor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e656ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 69
// module chunks = 0